import 'core-js/stable';
const axios = require('axios');
import simpleParallax from 'simple-parallax-js';
window.simpleParallax = simpleParallax;
import ScrollMagic from 'scrollmagic';
window.ScrollMagic = ScrollMagic;

// need a replace prototype because we need to replace things.
DOMTokenList.prototype.replace = function (a, b) {
    var arr = Array(this);
    var regex = new RegExp(arr.join("|").replace(/ /g, "|"), "i");
    if (!regex.test(a)) {
        return this;
    }
    this.remove(a);
    this.add(b);
    return this;
}

// register service worker
// if ('serviceWorker' in navigator) {
//     window.addEventListener('load', function() {
//         navigator.serviceWorker.register('/sw.js', {
//             scope: "/"
//         }).then(function(registration) {
//             // Registration was successful
//             console.log('ServiceWorker registration successful with scope: ', registration.scope);
//             // Trim the caches on load
//             navigator.serviceWorker.controller && navigator.serviceWorker.controller.postMessage({
//                 command: "trimCaches"
//             });
//        }).catch(function(err) {
//             // registration failed :(
//             console.log('ServiceWorker registration failed: ', err);
//         });
//     });
// }

// GO!
document.addEventListener( 'DOMContentLoaded', function () {
	//lazy load our background images
	const lazylozad = lozad(); // lazy loads elements with default selector as '.lozad'
	lazylozad.observe();

	//make external links target new tab/window
	var outboundlinks = document.querySelectorAll('[href*="https://"],[href*="http://"]');
	outboundlinks.forEach(l => {
		if (l.href.indexOf(window.location.hostname) == -1) {
			l.setAttribute('target', '_blank');
		}
	});

	// instantiate any splides
	if (document.querySelectorAll('.splide-carousel').length > 0) {
		new Splide( '.splide-carousel', {
			type   		: 'loop',
			perPage		: 1,
			perMove		: 1,
			autoWidth	: true,
			focus    	: 'center',
		} ).mount();
	}


	//different parallax settings used by parallaxed sections
	var images = document.querySelectorAll('[data-parallax]');
	new simpleParallax(images, {
			orientation: 'down',
			overflow: false,
			scale: 1.25
		});

	var revlax = document.querySelectorAll('[data-parallax-rev]');
	new simpleParallax(revlax, {
			orientation: 'up',
			overflow: true,
			scale: 1.5
		});

	var revlaxx = document.querySelectorAll('[data-parallax-revx]');
	new simpleParallax(revlaxx, {
			orientation: 'up',
			overflow: true,
			// duration: revlaxx.offsetHeight,
			duration: window.innerHeight -100,
			scale: .5
		});


	// set up generic scrollmagic controller used in various alpine scripts
	window.controller = new ScrollMagic.Controller({
		globalSceneOptions: {
			triggerHook: 'onLeave',
			// duration: "" // this works just fine with duration 0 as well
			// However with large numbers (>20) of pinned sections display errors can occur so every section should be unpinned once it's covered by the next section.
			// Normally 100% would work for this, but here 200% is used, as Panel 3 is shown for more than 100% of scrollheight due to the pause.
		}
	});

	// Handle ajax for generic contact forms
	const formContact = document.querySelector('#formContact');
	if (formContact) {
		formContact.addEventListener('submit', event => {
			event.preventDefault();
			const formData = new FormData(formContact);
	
			axios.post('/wheelform/message/send', formData)
				.then(function (response) {
					if (response.data.errors) {// display errors
						let errorsHTML = '',
							errors = Object.values(response.data.errors);
						for(let i = 0; i < errors.length; i++) {
							errorsHTML += '<p class="err">'+ errors[i] +'</p>';
						}
						document.querySelector(".errors").innerHTML = errorsHTML;
					} else {// display thank you
						document.getElementById("formContact").classList.add('hidden');
						document.getElementById("formContactThanks").classList.remove('hidden');
					}
				})
				.catch(function (error) {
					document.getElementById("form-contact").innerHTML = '<div><h3>Sorry, there was an error.</h3><p>The following errors were encountered:</p><p class="text-dcired">'+ error +'</p></div>';
				});
		});
	}
} );